var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9875 4C5.36468 4 1 7.47567 1 11.7645C1 16.0524 5.36468 19.5286 11.9875 19.5286C18.6114 19.5286 22.977 16.0524 22.977 11.7645C22.977 7.47567 18.6114 4 11.9875 4Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9458 14.666C15.8325 14.3385 22.2031 13.0275 21.4182 9.3921C21.1357 8.08816 19.7944 6.65382 17.7707 5.65665C16.1534 4.92887 14.1793 4.50635 11.9621 4.50635C5.81333 4.50635 1.5376 7.7556 1.5376 11.7645C1.5376 14.5563 3.6133 16.9803 6.95099 18.1932C7.65907 16.3293 10.4792 15.2674 13.9458 14.666Z",
    fill: "#0075C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0007 15.9517C9.24375 16.2979 7.97872 17.1885 7.16553 18.27C8.57055 18.7507 10.1873 19.0216 11.9613 19.0216C18.1106 19.0216 22.3863 15.7733 22.3863 11.7645C22.3863 11.4092 22.3525 11.0599 22.2868 10.7183C22.0831 15.4251 15.0175 15.5772 12.0007 15.9517Z",
    fill: "url(#paint0_linear_3925_20056)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5443 13.7427C14.5135 13.402 14.5009 13.1695 14.5009 12.9694V10.9356H13.5214L13.5527 10.9983C13.5538 10.9998 13.6523 11.1949 13.6523 11.6215L13.6523 11.6251C13.6525 11.7054 13.6549 13.0429 13.6164 13.3661C13.3799 13.4268 13.0635 13.4485 12.8583 13.4485C11.3042 13.4485 10.5153 12.556 10.5153 10.7977C10.5153 9.45531 11.4033 8.45309 12.6738 8.36111C13.3425 8.3136 13.9859 8.49554 14.3912 8.84731L14.462 8.90897V8.08718L14.4281 8.08061C14.0243 8.00277 13.5502 7.9209 13.0863 7.9209C10.8488 7.9209 9.51202 9.099 9.51202 11.0716C9.51202 13.1731 11.144 13.9216 12.6718 13.9216C13.3192 13.9216 13.9889 13.8736 14.509 13.7881L14.5479 13.7816L14.5443 13.7427ZM4.9509 8.49414C5.06967 8.48403 5.43357 8.45775 5.69688 8.45775C7.27122 8.45775 8.00557 9.22091 8.00557 10.8599C8.00557 12.5536 7.3531 13.3779 6.01225 13.3779C5.03076 13.3779 4.9509 13.3304 4.9509 12.7486V8.49414ZM6.02836 7.97454H3.96631L3.99057 8.03368C4.08205 8.25605 4.07649 8.66139 4.07042 9.02023C4.0679 9.10463 4.06688 13.7806 4.06688 13.7806L4.10782 13.7817C4.11742 13.7827 5.04737 13.816 5.9288 13.816C7.7705 13.816 9.00823 12.5677 9.00823 10.7098C9.00823 9.04802 7.83873 7.97454 6.02836 7.97454ZM16.9984 8.43023H16.4222L16.4192 10.42H16.7952C17.8161 10.42 18.2917 10.0794 18.2917 9.34755C18.2917 8.70467 17.9061 8.43023 16.9984 8.43023ZM16.874 10.8759H16.4192V12.7889C16.4192 13.2124 16.5981 13.3777 17.0555 13.3777C17.9991 13.3777 18.458 12.9602 18.458 12.102C18.458 11.2883 17.9263 10.8759 16.874 10.8759ZM19.1357 9.22928C19.1357 9.94999 18.6 10.4438 18.04 10.5929C18.8845 10.7738 19.4592 11.3555 19.4592 12.0499C19.4592 13.1719 18.6091 13.8158 17.1267 13.8158C16.3472 13.8158 15.7057 13.8273 15.5984 13.8292C15.5887 13.8294 15.5833 13.8295 15.5827 13.8295L15.5393 13.8305V8.79564C15.5393 8.26042 15.4882 8.02894 15.4872 8.02642L15.4756 7.97436H17.2395C18.4277 7.97436 19.1357 8.44287 19.1357 9.22928Z",
    fill: "#FEFEFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3925_20056",
    x1: 23.199,
    y1: 13.136,
    x2: 7.77289,
    y2: 14.1467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AB935"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.305922,
    stopColor: "#00A5A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669783,
    stopColor: "#008AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075C1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24);
export default __webpack_public_path__ + "static/media/하이투자증권-24.4cb9bfdbc8ce58480f87914bbdd609e7.svg";
export { ForwardRef as ReactComponent };